<template>
  <div class="join_in">
    <div class="header"></div>
    <div class="content">
      <div class="item_header">
        <div class="itr_item" v-for="(item, index) in dataItr" :key="index">
          <img :src="item.src" alt="图片加载失败" />
          <p>{{ item.test }}</p>
        </div>
      </div>
      <div class="item_body">
        <h2 class="title">
          <span>招商加盟</span>
          <p class="p1"></p>
          <p class="p2"></p>
          <p class="p3"></p>
          <p class="p4"></p>
        </h2>
        <!-- 表单 -->
        <van-form class="my_form" ref="myForm" validate-trigger="onBlur" :validate-first="true" @submit="submitForm">
          <!-- 手机号 -->
          <van-field v-model="dataForm.linkPhone" type="tel" name="手机号" clearable placeholder="请填写你的手机号" :rules="[{ validator: checkPhone, message: '' }]" />
          <!-- 验证码 -->
          <van-field v-model="dataForm.verCode" type="digit" name="验证码" placeholder="请填写验证码" clearable :rules="[{ required: true, message: '' }]">
            <template #button>
              <van-button class="btn_msg" size="small" type="primary" native-type="button" :disabled="downTime > 0" @click="sendMsg">
                {{ downTime > 0 ? downTime + "秒后重发" : "获取验证码" }}
              </van-button>
            </template>
          </van-field>
          <!-- 商家类型 -->
          <van-field readonly clickable clearable :is-link="true" arrow-direction="down" :value="dataForm.typeName" placeholder="请选择类型" @click="showBusiness = true" :rules="[{ required: true, message: '', trigger: 'onChange' }]" />
          <van-popup v-model="showBusiness" round position="bottom">
            <van-picker show-toolbar value-key="test" :columns="businessList" @cancel="showBusiness = false" @confirm="onConfirmBusiness" />
          </van-popup>
          <!-- 经营业态 -->
          <van-field readonly clickable clearable :is-link="true" arrow-direction="down" :value="dataForm.scopeName" placeholder="请选择经营业态" @click="showScope = true" :rules="[{ required: true, message: '', trigger: 'onChange' }]" />
          <van-popup v-model="showScope" round position="bottom">
            <van-picker show-toolbar value-key="test" :columns="scopeList" @cancel="showScope = false" @confirm="onConfirmScope" />
          </van-popup>
          <!-- 姓名 -->
          <van-field v-model="dataForm.linkPerson" type="text" name="姓名" clearable placeholder="请填写你的姓名" :rules="[{ validator: checkPerson, message: '' }]" />
          <!-- 公司名称 -->
          <van-field v-model="dataForm.name" type="text" clearable name="公司名称" placeholder="请填写你的公司名称" :rules="[{ validator: checkName, message: '' }]" />
          <!-- 所在城市 -->
          <van-field readonly clickable clearable :is-link="true" arrow-direction="down" :value="selectName" placeholder="请选择所在城市" @click="showArea = true" :rules="[
              { validator: checkArea, message: '', trigger: 'onChange' },
            ]" />
          <van-popup v-model="showArea" round position="bottom">
            <van-area :area-list="areaList" :columns-placeholder="['请选择', '请选择', '请选择']" @confirm="onConfirmArea" @cancel="showArea = false" @change="onChangeArea" />
          </van-popup>
          <!-- 详细地址 -->
          <van-field v-model="dataForm.addr" rows="2" clearable autosize type="textarea" placeholder="请填写详细地址" :rules="[{ required: true, message: '' }]" />
          <!-- 为您服务 -->
          <van-field v-model="dataForm.salesman" type="text" clearable name="为您服务" placeholder="为您服务的销售经理（选填）" :rules="[{ validator: checkSalesman, required: false, message: '' }]" />
          <van-button type="primary" round block native-type="submit" class="sub_btn">立即加盟</van-button>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import { GetProList, GetDisList } from "@/pages/page1/api/modules/common";
import {
  SendVerCodeRegister,
  SubmitRegister,
  RegisterCheck,
} from "@/pages/page1/api/modules/user";
import { Button, Form, Field, Picker, Toast, Popup, Area } from "vant";
import { validMobile, validatetypeName } from "@/pages/publicUtils/validate";
export default {
  metaInfo: { title: "立即加盟 - 多比商城" },
  nameL: "joinIn",
  components: {
    [Button.name]: Button,
    [Form.name]: Form,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Area.name]: Area,
  },
  data() {
    return {
      dataItr: [
        {
          src: require("@/assets/img/join1.png"),
          test: "线上商城·数字化管理系统",
        },
        {
          src: require("@/assets/img/join4.png"),
          test: "线下连锁体验店",
        },
        {
          src: require("@/assets/img/join3.png"),
          test: "全品类优质家具供应链",
        },
        {
          src: require("@/assets/img/join2.png"),
          test: "多渠道流量赋能",
        },
      ],
      dataForm: {
        linkPhone: "",
        verCode: "",
        linkPerson: "",
        name: "",
        salesman: "",
        // 商家类型
        typeName: "",
        type: "",
        // 经营业态
        scopeName: "",
        scope: "",
        // 城市
        proName: "",
        proCode: "",
        cityName: "",
        cityCode: "",
        areaName: "",
        areaCode: "",
        // 详细地址
        addr: "",
        // 渠道 1微信 2商城
        addWay: 1,
        aloneDo: true,
      },
      downTime: 0,
      //选择框
      showBusiness: false,
      showScope: false,
      showArea: false,
      businessList: [
        { value: 3, test: "家具工厂" },
        { value: 1, test: "服务商" },
        { value: 2, test: "直销商" },
      ],
      scopeList: [
        { value: 5, test: "家具制造" },
        { value: 1, test: "装修公司" },
        { value: 2, test: "家具店" },
        { value: 3, test: "建材店" },
        { value: 4, test: "其他" },
      ],
      areaList: {
        province_list: {},
        city_list: {},
        county_list: {},
      },
    };
  },
  mounted() {
    // 进入页面 初始化根节点字体大小，使用rem单位
    let contentWidth =
      document.documentElement.clientWidth || document.body.clientWidth;
    let fontSize = (contentWidth * 18) / 375;
    document.documentElement.style.fontSize = fontSize + "px";
    // alert(contentWidth);

    // 获取省数据
    this.getProList();
  },
  methods: {
    getProList() {
      GetProList({}).then((res) => {
        // console.log("获取省市", res);
        res.data.forEach((item) => {
          this.areaList.province_list[item.code] = item.name;
          item.children.forEach((v) => {
            this.areaList.city_list[v.code] = v.name;
          });
        });
        // console.log(this.areaList);
      });
    },
    onConfirmBusiness(v, index) {
      //  console.log(v);
      this.dataForm.type = v.value;
      this.dataForm.typeName = v.test;
      this.showBusiness = false;
    },
    onConfirmScope(v, index) {
      this.dataForm.scope = v.value;
      this.dataForm.scopeName = v.test;
      this.showScope = false;
    },
    onConfirmArea(vArr, index) {
      //   console.log(vArr);
      if (!vArr[1]) {
        vArr[1] = { code: "", name: "" };
      }
      if (!vArr[2]) {
        vArr[2] = { code: "", name: "" };
      }
      this.dataForm.proCode = vArr[0].code;
      this.dataForm.proName = vArr[0].name;
      this.dataForm.cityCode = vArr[1].code;
      this.dataForm.cityName = vArr[1].name;
      this.dataForm.areaCode = vArr[2].code;
      this.dataForm.areaName = vArr[2].name;
      this.showArea = false;
      //   console.log(this.dataForm);
    },
    onChangeArea(Picker, vArr, index) {
      //   console.log(vArr);
      if (!vArr[1]) {
        vArr[1] = { code: "", name: "" };
      }
      if (!vArr[2]) {
        vArr[2] = { code: "", name: "" };
      }
      // 选择市请求区
      if (vArr[1].code && !vArr[2].code) {
        let obj = {};
        GetDisList({ cityCode: vArr[1].code }).then((res) => {
          //   console.log("获取区域", res);
          res.data.forEach((item) => {
            obj[item.code] = item.name;
            this.areaList.county_list = obj;
          });
          //   console.log(this.areaList);
        });
      }
    },
    sendMsg() {
      this.$refs.myForm.validate("手机号").then(() => {
        SendVerCodeRegister({ mobile: this.dataForm.linkPhone }).then((res) => {
          // console.log("获取验证码", res);
          this.dataForm.verCode = res.data[0].verCode;
          this.downTime = 60;
          let aTime = setInterval(() => {
            this.downTime -= 1;
            //   console.log(this.downTime);
            if (this.downTime <= 0) {
              clearInterval(aTime);
            }
          }, 1000);
        });
      });
    },
    submitForm() {
      SubmitRegister(this.dataForm).then((res) => {
        // console.log("提交商家加盟登记接口", res);
        if (res.isSuccess === 1) {
          this.$router.push({
            path: "/joinResult",
            query: {
              customerName: res.data[0].customerName,
            },
          });
        } else {
          Toast.fail(res.message || "发生异常");
        }
      });
    },
    // 验证
    async checkPhone(val) {
      //   console.log(val);
      if (!val) {
        return false;
      }
      if (!validMobile(val)) {
        Toast("手机号格式不对");
        return false;
      }
      if (val && validMobile(val)) {
        let result = await this.checkPhoneByUrl();
        // console.log("验证手机是否加盟？", result);
        if (result.data.length > 0) {
          //已加盟有数据
          this.$router.push({
            path: "/joinResult",
            query: {
              customerName: result.data[0].linkPerson,
            },
          });
          return false;
        } else {
          return true;
        }
      }
    },
    checkPerson(val) {
      if (!val) {
        return false;
      }
      if (!validatetypeName(val)) {
        Toast("姓名请输入中文或英文");
        return false;
      }
      if (val.length < 2 || val.length > 10) {
        Toast("姓名请输入2到10个文字");
        return false;
      }
      return true;
    },
    checkName(val) {
      if (!val) {
        return false;
      }
      if (!validatetypeName(val)) {
        Toast("公司名称请输入中文或英文");
        return false;
      }
      if (val.length < 2 || val.length > 20) {
        Toast("公司名称请输入2到20个文字");
        return false;
      }
      return true;
    },
    checkArea(val) {
      //   console.log(val);
      if (!val) {
        return false;
      }
      if (!this.dataForm.areaName) {
        Toast("请选择完整的城市");
        return false;
      }
      return true;
    },
    checkSalesman(val) {
      // console.log(val);
      if (!val) {
        return true;
      }
      if (!validatetypeName(val)) {
        Toast("经理名称请输入中文或英文");
        return false;
      }
      if (val.length < 2 || val.length > 20) {
        Toast("经理名称请输入2到20个文字");
        return false;
      }
      return true;
    },
    checkPhoneByUrl() {
      return new Promise((resolve) => {
        let params = { mobile: this.dataForm.linkPhone, aloneDo: true };
        RegisterCheck(params).then((res) => {
          // console.log("验证手机是否加盟？", res);
          resolve(res);
        });
      });
    },
  },
  computed: {
    selectName: function () {
      if (
        !this.dataForm.proName &&
        !this.dataForm.cityName &&
        !this.dataForm.areaName
      ) {
        return null;
      }
      return (
        this.dataForm.proName +
        " " +
        this.dataForm.cityName +
        " " +
        this.dataForm.areaName
      );
    },
  },
};
</script>

<style lang="less" scoped>
.join_in {
  background-color: #1b30c8;
  .header {
    height: 11.11111rem;
    background: url("~@/assets/img/join5.jpg") no-repeat center;
    background-size: contain;
  }
  .content {
    background-color: #1b30c8;
    padding: 0 0.86rem 1.11rem;
    .item_header {
      width: 100%;
      height: 13.84rem;
      box-sizing: border-box;
      padding-top: 1.11rem;
      margin-bottom: 0.7rem;
      background-color: #fff;
      border-radius: 7px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .itr_item {
        width: 50%;
        height: 49%;
        box-sizing: border-box;
        font-size: 0.56rem;
        color: #1b30c8;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 1.34rem;
        img {
          max-width: 3.67rem;
          height: auto;
        }
      }
    }
    .item_body {
      background-color: #fff;
      border-radius: 7px;
      width: 100%;
      box-sizing: border-box;
      padding: 0rem 2.99rem 1.64rem 2.99rem;
      .title {
        padding-top: 1rem;
        margin-bottom: 1.4rem;
        font-size: 0.833rem;
        font-weight: bold;
        color: #1b30c8;
        text-align: center;
        position: relative;
        .p1 {
          background-color: #1b30c8;
          width: 3.125rem;
          height: 2px;
          position: absolute;
          top: 1.4583rem;
          left: 0.417rem;
        }
        .p2 {
          background-color: #1b30c8;
          width: 1.5625rem;
          height: 2px;
          position: absolute;
          top: 1.7708rem;
          left: 0.417rem;
        }
        .p3 {
          background-color: #1b30c8;
          width: 3.125rem;
          height: 2px;
          position: absolute;
          top: 1.4583rem;
          right: 0.417rem;
        }
        .p4 {
          background-color: #1b30c8;
          width: 1.5625rem;
          height: 2px;
          position: absolute;
          top: 1.7708rem;
          right: 0.417rem;
        }
      }
      .my_form {
        /deep/ .van-field {
          border: 1px solid #313131;
          border-radius: 3px;
          margin-bottom: 0.875rem;
          padding: 0.28rem 0.44rem;
          font-size: 0.6rem;
          .van-field__control {
            font-size: 0.6rem;
          }
          .btn_msg {
            height: 1.333rem;
            font-size: 0.6rem;
          }
        }
        .sub_btn {
          width: 100%;
          height: 2.08rem;
          background: linear-gradient(-90deg, #1b30c8, #8b92fe);
          border: none;
          border-radius: 3px;
          font-size: 0.8333rem;
        }
      }
    }
  }
}
</style>